import clsx from 'clsx';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import logo from '@assets/654global.svg';
import Icon from '@components/Icon/Icon';
import { EIcons } from '@enums/icons.enum';
import { ERoutes } from '@enums/routes.enum';
import { EStyles } from '@enums/style.enum';
import { reset } from '@store/auth/authSlice';
import type { RootState } from '@store/store';

import classes from './AppHeader.module.scss';

type Props = {
	goBack?: () => void;
	showBorder?: boolean;
	title?: string;
};

export const AppHeader: React.FC<Props> = ({ goBack, showBorder = false, title }: React.PropsWithChildren<Props>) => {
	const flightNumber = useSelector((state: RootState) => state.trips.flightNumber);
	const airline = useSelector((state: RootState) => state.trips.airline);

	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	useEffect(() => {
		if (!flightNumber && !title) {
			dispatch(reset());
			navigate(ERoutes.search);
		}
	}, [flightNumber, title]);

	return (
		<div className={clsx(classes['headerContainer'], showBorder && classes['headerContainerBorder'])}>
			{goBack && (
				<button className={classes['backButtonContainer']} onClick={goBack}>
					<Icon name={EIcons.Back} size={22} color="var(--text)" />
				</button>
			)}
			<h1 className={classes['title']}>
				{title
					? title
					: flightNumber
						? `${EStyles.hash}${flightNumber} ${airline ? `${EStyles.hyphen} ${airline}` : EStyles.emptyQuote}`
						: t('rateTrip.title')}
			</h1>
			<img src={logo} alt="654 Global" className={classes['logo']} />
		</div>
	);
};
